<template>
  <el-dialog width="700px" append-to-body title="新增收款账号" :visible.sync="visible" :before-close="handleClose">
    <el-form class="xm-form" autoComplete="on" :model="account" v-loading="loading" :rules="accountRules"
      element-loading-text="给我一点时间" label-position="right" ref="account" label-width="120px" label-suffix="：">
      <el-form-item label="收款人" prop="payee">
        <el-input type="text" style="width:350px" v-model="account.payee" placeholder="请输入姓名"> </el-input>
      </el-form-item>
      <el-form-item label="收款方式" prop="method">
        <el-radio-group v-model="account.method">
          <el-radio :label="0">微信</el-radio>
          <el-radio :label="1">支付宝</el-radio>
          <el-radio :label="2">银行卡</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="account.method == 2">
        <el-form-item label="开户行" prop="bank_name">
          <el-input type="text" style="width:350px" v-model="account.bank_name" placeholder="请输入开户银行">
          </el-input>
        </el-form-item>
        <el-form-item label="银行行号" prop="bank_code">
          <el-input type="text" style="width:350px" v-model="account.bank_code" placeholder="请输入银行行号">
          </el-input>
        </el-form-item>
      </template>
      <el-form-item label="收款账号" prop="account">
        <el-input type="text" style="width:350px" v-model="account.account" placeholder="请输入收款账号">
        </el-input>
      </el-form-item>
      <el-form-item label="是否默认" prop="is_default">
        <el-switch v-model="account.is_default" :active-value="1" :inactive-value="0">
        </el-switch>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="handleClose">取消</el-button> -->
      <el-button v-waves type="primary" @click.native.prevent="handleAddAccount" :loading="loading">保存账号</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveAccount } from '@/api/account'
import waves from '@/directive/waves'; // 水波纹指令

export default {
  name: 'AddAccount',
  components: {},
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  watch: {
    visible(value) {
      if (value) {

      }
    }
  },
  data() {
    return {
      loading: false,
      account: {
        id: 0,
        payee: '',
        method: 0,
        bank_name: '',
        bank_code: '',
        account: '',
        is_default: 0,
      },
      accountRules: {
        payee: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请选择收款账号', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    // 新增账号
    handleAddAccount() {
      // 验证form表单
      this.$refs.account.validate((valid) => {
        if (valid) {
          this.loading = true;
          const _account = JSON.parse(JSON.stringify(this.account))
          saveAccount(_account)
            .then((response) => {
              this.loading = false;
              // 关闭窗口
              this.handleClose();
              // 触发父组件的callback事件
              this.$emit('getList');
              // 弹出操作提示
              this.$message({
                type: 'success',
                message: '保存成功!'
              });
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.account) {
        this.$refs.account.resetFields();
      }
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>